export default __webpack_public_path__ + "static/media_03-8558fe4fe6b840fb5994c0dbb681bcfc.jpg";